import { render, staticRenderFns } from "./Workers.vue?vue&type=template&id=3dab801f&scoped=true"
import script from "./Workers.vue?vue&type=script&lang=js"
export * from "./Workers.vue?vue&type=script&lang=js"
import style0 from "./Workers.vue?vue&type=style&index=0&id=3dab801f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dab801f",
  null
  
)

export default component.exports